import dayjs from 'dayjs';

import { printMissingConfigError, SessionStorageManager, SiteConfigManager } from '@atlas/core';

import { POPUP_SIGN_UP_DELAY_STORAGE_KEYS } from 'common/constants';

export const getDelayOfPopupSignUp = () => {
  const firstDelay = SiteConfigManager.getConfig('config.config.registration.mobile_popup_delay');
  const firstDelayMs = firstDelay * 1000;
  const nextDay = SessionStorageManager.getItem(POPUP_SIGN_UP_DELAY_STORAGE_KEYS.NEXT_SHOW);
  const delayToNextShow = Number(nextDay || 0) - dayjs().valueOf();

  if (!firstDelay) {
    printMissingConfigError('config.config.registration.mobile_popup_delay');
  }

  return delayToNextShow > firstDelayMs ? delayToNextShow : firstDelayMs;
};
